import React, { useEffect } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Col,
  Table,
} from "reactstrap";
import { ELC_FORMS } from "../ELCForms/constants";
import PreOfferDocuments from "../PreOfferDocuments/PreOfferDocuments";

const PreOfferVerification = ({
  selectedCandidate,
  toggleTab,
  activeTab,
  tosData,
}) => {

  return (
    <React.Fragment>
      <Nav tabs>
        <NavItem className="ms-2">
          <NavLink
            style={{ cursor: "pointer" }}
            className={activeTab === 1 ? "active" : ""}
            onClick={() => {
              toggleTab(1);
            }}
          >
            Terms of Service (ToS)
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={activeTab === 2 ? "active" : ""}
            onClick={() => {
              toggleTab(2);
            }}
          >
            Documents
          </NavLink>
        </NavItem>
      </Nav>
      <div className="offcanvas-body p-4">
        <TabContent activeTab={activeTab}>
          {/* Candidate Details */}
          <TabPane tabId={1}>
            <div className="row">
              {ELC_FORMS.map((section, index) => (
                <div className="content-wrapper-pov" key={index}>
                  <div className="elc-form-section-title">
                    <span
                      className="fw-semibold fs-5"
                      style={{ color: "rgb(10, 86, 174)" }}
                    >
                      {section.section}
                    </span>
                  </div>
                  <Col lg={12} className="d-flex flex-row flex-wrap">
                    {section.fields.map((field, index) => {
                      let tosDataValue = tosData?.[field.name];
                      let tosLabel = field.label;
                      const generateBenefitsTable = (benefits) => {
                        if (benefits === null || benefits === undefined) {
                          // No benefits added
                          return (
                            <div className="fw-semibold" key={index}>
                              NA
                            </div>
                          );
                        } else {
                          const data = JSON.parse(benefits);
                          const headers = Object.keys(data[0]).filter(
                            (header) => header !== "key"
                          );
                          return (
                            <Table
                              className="table-bordered align-middle table-nowrap mb-0"
                              style={{ borderColor: "#d3d3d3" }}
                              key={index}
                            >
                              <thead
                                className="table-light"
                                style={{ borderColor: "#d3d3d3" }}
                              >
                                <tr>
                                  {headers.map((header, index) => (
                                    <th className="text-capitalize" key={index}>
                                      {header}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {data.map((item, rowIndex) => (
                                  <tr key={rowIndex}>
                                    {headers.map((header, cellIndex) => (
                                      <td key={cellIndex}>{item[header]}</td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          );
                        }
                      };
                      return (
                        <>
                          {tosLabel === "Benefits" ? (
                            <Col lg={12}>
                              <div className="d-flex flex-column gap-1 align-items-start mt-2">
                                <div
                                  style={{ fontSize: "11px" }}
                                  className="w-100"
                                >
                                  {generateBenefitsTable(tosDataValue)}
                                </div>
                              </div>
                            </Col>
                          ) : (
                            <Col lg={4}>
                              <div className="d-flex flex-column gap-1 align-items-start mt-2">
                                <div style={{ fontSize: "12px" }}>
                                  {tosLabel}
                                </div>
                                <div className="fw-semibold">
                                  <span>
                                    {tosDataValue && tosDataValue.length > 0
                                      ? tosDataValue
                                      : "N/A"}
                                  </span>
                                </div>
                              </div>
                            </Col>
                          )}
                        </>
                      );
                    })}
                  </Col>
                </div>
              ))}
            </div>
            {/* Pre-Offer Documents */}
          </TabPane>
          <TabPane tabId={2}>
            {selectedCandidate && (
              <div className="row">
                <div className="content-wrapper-pov">
                  <PreOfferDocuments
                    jobId={selectedCandidate?.jobEnity?.id}
                    candidateId={selectedCandidate?.candidate?.id}
                  />
                </div>
              </div>
            )}
          </TabPane>
        </TabContent>
      </div>
    </React.Fragment>
  );
};
export default PreOfferVerification;
